<template>
  <div class="card">
    <div class="main-card-body">
      <div class="main-body__css">
        <div class="synthetic-salary card card-md-12">
            <el-card>
              <div slot="header">
                <p class="card-header__title">
                  Tổng hợp nhân sự
                </p>
              </div>
              <div class="card-body-md-12 card-body--flex">
                <a
                  href="/admin/EmployeeManager/list?filters=status:in:DANG_LAM_VIEC,NGHI_SINH"
                  class="mouse-hover-pointer total-employee"
                  @click="goToEmployeeStatus"
                >
                  <div>
                    <div class="title--text">Tổng nhân viên</div>
                    <div class="total-employee__value">
                      <b class="value">
                        {{
                          totalEmployee >= 10
                            ? totalEmployee
                            : `0${totalEmployee}`
                        }}
                      </b>
                      <span class="unit"> nhân sự</span>
                    </div>
                  </div>
                </a>
                <a
                  href="/admin/EmployeeManager/list?filters=status:in:DANG_LAM_VIEC"
                  class="mouse-hover-pointer working"
                  @click="goToEmployeeStatusWorking"
                >
                  <div>
                    <div class="title--text">Đang làm việc</div>
                    <div class="working__value">
                      <b class="value">
                        {{
                          totalEmployeeWorking >= 10
                            ? totalEmployeeWorking
                            : `0${totalEmployeeWorking}`
                        }}
                      </b>
                      <span class="unit"> nhân sự</span>
                    </div>
                  </div>
                </a>
                <a
                  :href="`/admin/EmployeeManager/list?filters=status%3Ain%3ADANG_LAM_VIEC,NGHI_SINH%26salary.insurance_salary%3Ais_null%3Afalse`"
                  class="mouse-hover-pointer maternity-leave"
                  @click="goToEmplopyeeInsurance"
                >
                  <div>
                    <div class="title--text">Bảo hiểm</div>
                    <div class="maternity-leave__value">
                      <b class="value">
                        {{
                          totalMaternityLeave >= 10
                            ? totalMaternityLeave
                            : `0${totalMaternityLeave}`
                        }}
                      </b>
                      <span class="unit"> nhân sự</span>
                    </div>
                  </div>
                </a>
              </div>
            </el-card>
        </div>
        <div class="personnel-contract card card-md-12">
          <el-card>
            <div slot="header">
              <p class="card-header__title">Hợp đồng nhân sự</p>
            </div>
            <div class="card-body-md-12">
              <b-row>
                <b-col md="4" sm="6">
                  <div class="card-body__block total-contract__block" @click="goToEmployeeListValidated">
                    <p class="count mb-4">
                      {{
                        totalEmployeeContract >= 10
                          ? totalEmployeeContract
                          : `0${ totalEmployeeContract }`
                      }}
                    </p>
                    <p class="title">
                      Tổng số <br/>hợp đồng
                    </p>
                    <div class="icon">
                      <i class="isax-bold-document-text-1"></i>
                    </div>
                  </div>
                </b-col>
                <b-col md="4" sm="6">
                  <div class="card-body__block contract-expire__block" @click="goToEmployeeAboutToExpire">
                    <p class="count mb-4">
                      {{
                        totalContractToBeExpired >= 10
                          ? totalContractToBeExpired
                          : `0${ totalContractToBeExpired }`
                      }}
                    </p>
                    <p class="title">
                      Hợp đồng <br/>sắp hết hạn
                    </p>
                    <div class="icon">
                      <i class="isax-bold-document-copy"></i>
                    </div>
                  </div>
                </b-col>
                <b-col md="4" sm="6">
                  <div class="card-body__block overdue-contract__block" @click="goToEmployeeListExpired">
                    <p class="count mb-4">
                      {{
                        totalContractExpired >= 10
                          ? totalContractExpired
                          : `0${ totalContractExpired }`
                      }}
                    </p>
                    <p class="title">
                      Hợp đồng <br/>hết hạn
                    </p>
                    <div class="icon">
                      <i class="isax-bold-note-favorite"></i>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </el-card>
        </div>
        <el-row :gutter="15" class="mb-3">
          <el-col :sm="24" :md="12">
            <div class="type-contract card chart-card">
              <el-card>
                <div slot="header">
                  <p class="card-header__title">Loại hợp đồng</p>
                </div>
                <div class="card-body-md-12 card-body__chart">
                  <EChart
                    v-if="showChartTypeContract"
                    :optionChart="optionChartTypeContract"
                    @chartClick="chartClickEvent"
                    :chartId="'typeContract'"
                  />
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :sm="24" :md="12">
            <div class="work-experience card chart-card">
              <el-card>
                <div slot="header">
                  <p class="card-header__title">Kinh nghiệm làm việc</p>
                </div>
                <div class="card-body-md-12 card-body__chart">
                  <EChart
                    v-if="showChartWorkExperience"
                    :optionChart="optionChartWorkExperience"
                    :heightChart="'410'"
                    @chartClick="chartClickEvent"
                    :chartId="'workExperience'"
                  />
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="mb-3">
          <el-col :sm="24" :md="12">
            <div class="personnel-by-department card chart-card">
              <el-card>
                <div slot="header">
                  <p class="card-header__title">Biểu đồ thống kê nhân sự theo bộ phận</p>
                </div>
                <div class="card-body-md-12 card-body__chart">
                  <EChart
                    v-if="showChartPersonnelByDepartment"
                    :optionChart="optionChartPersonnelByDepartment"
                    :heightChart="'410'"
                    @chartClick="chartClickEvent"
                    :chartId="'personnelByDepartment'"
                  />
                </div>
              </el-card>
            </div>
          </el-col>
          <!-- <el-col :sm="24" :md="12">
            <div class="salary-paid card chart-card">
              <el-card>
                <div slot="header">
                  <p class="card-header__title">Biểu đồ thống kê mực lương chi trả</p>
                </div>
                <div class="card-body-md-12">
                  <EChart
                    :optionChart="optionChartSalaryPaid"
                  />
                </div>
              </el-card>
            </div>
          </el-col> -->
          <el-col :sm="24" :md="12">
            <div class="gender card chart-card">
              <el-card>
                <div slot="header">
                  <p class="card-header__title">Giới tính</p>
                </div>
                <div class="card-body-md-12 card-body__chart">
                  <EChart
                    v-if="showChartGender"
                    :heightChart="'400'"
                    :optionChart="optionChartGender"
                    @chartClick="chartClickEvent"
                    :chartId="'chartGende'"
                  />
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import EChart from '../../../../component/EChart/EChart'
import MethodService from '../../../../service/MethodService'
import DataService from '../../../../service/DataService'
import { Filter } from "mushroomjs"
import { blockUi, unblockUi } from '../../../../shared/utils'
export default {
  props: {
    listDepartment: {
      type: Array,
      default: () => [],
    },
    listEmployee: {
      type: Array,
      default: () => [],
    },
    listContractType: {
      type: Array,
      default: () => [],
    }
  },
  components: {
    EChart,
  },
  data() {
    return {
      showChartPersonnelByDepartment: false,
      showChartGender: false,
      showChartWorkExperience: false,
      showChartTypeContract: false,
      totalEmployee: 0,
      totalEmployeeWorking: 0,
      totalMaternityLeave: 0,
      totalEmployeeContract: 0,
      totalContractToBeExpired: 0,
      totalContractExpired: 0,
      optionChartTypeContract: {},
      optionChartWorkExperience: {},
      optionChartPersonnelByDepartment: {},
      optionChartSalaryPaid: {},
      optionChartGender: {},
      arrContractTypeIds: [],
      constractValidity: undefined,
      seniority: undefined,
    }
  },
  methods: {
    chartClickEvent(dataEmit) {
      this.constractValidity = undefined
      this.seniority = undefined
      if (dataEmit.name == '0-1 năm') {
        this.goToEmployeeWorkExperience('0-1')
      } else if (dataEmit.name == '1-3 năm') {
        this.goToEmployeeWorkExperience('1-3')
      } else if (dataEmit.name == '3-5 năm') {
        this.goToEmployeeWorkExperience('3-5')
      } else if (dataEmit.name == '5-7 năm') {
        this.goToEmployeeWorkExperience('5-7')
      } else if (dataEmit.name == '7+ năm') {
        this.goToEmployeeWorkExperience('7-0')
      } else if (dataEmit.seriesName == 'Nhân sự') {
        this.goToEmployee(dataEmit.data.department_id)
      } else if (dataEmit.seriesName == 'Giới tính') {
        this.goToEmployeeGender(dataEmit.name)
      } else if (dataEmit.seriesName == 'Loại hợp đồng') {
        this.goToEmployeeContractType(dataEmit.data.id)
      } else {
        this.goToEmployeeStatus()
      }
    },
    goToEmployee(departmentId) {
      this.$router.push({
        name: 'Admin-EmployeeManager-list',
        query: {
          filters: `status:in:DANG_LAM_VIEC,NGHI_SINH${departmentId && typeof departmentId == 'string' ? `&job_info.department_id=${departmentId}` : ''}`
        }
      }).catch(() => {})
    },
    goToEmployeeStatus(e) {
      if (!e) return
      e.preventDefault()
      this.$router.push({
        name: 'Admin-EmployeeManager-list',
        query: {
          filters: `status:in:DANG_LAM_VIEC,NGHI_SINH`
        }
      }).catch(() => {})
    },
    goToEmployeeStatusWorking(e) {
      if (!e) return
      e.preventDefault()
      this.$router.push({
        name: 'Admin-EmployeeManager-list',
        query: {
          filters: `status:in:DANG_LAM_VIEC`
        }
      }).catch(() => {})
    },
    goToEmployeeListExpired() {
      this.constractValidity = 'expired'
      let arrContractTypeIds = MethodService.findListItemDifferent(this.listContractType, 'id')
      let filter = `status:in:DANG_LAM_VIEC,NGHI_SINH&job_info.contract_type_id:in:${arrContractTypeIds.join(',')}&job_info:nelemMatch:contract_type_id:in:${arrContractTypeIds.join(',').replace(/,/g, "\\,")},:or:end_date:is_null:true\\,end_date>=$$now`
      this.goToEmployeeFilter(filter)
    },
    goToEmployeeAboutToExpire() {
      this.constractValidity = 'about_to_expire'
      let arrContractTypeIds = MethodService.findListItemDifferent(this.listContractType, 'id')
      let filter1 = `job_info:nelemMatch:contract_type_id:in:${arrContractTypeIds.join(',').replace(/,/g, "\\,")},:or:end_date:is_null:true\\,end_date>=$$now+1months`
      let filter2 = Filter.elementMatch('job_info', [
        Filter.in("contract_type_id",arrContractTypeIds),
        Filter.and(
          Filter.lte('start_date', '$$now'),
          Filter.or(
            Filter.gte('end_date', '$$now'),
            Filter.gte('end_date', '$$now+1months')
          )
        )
      ]).build()
      let filter = `status:in:DANG_LAM_VIEC,NGHI_SINH&job_info.contract_type_id:in:${arrContractTypeIds.join(',')}&${filter1}&${filter2}`
      this.goToEmployeeFilter(filter)
    },
    goToEmployeeListValidated() {
      this.constractValidity = 'validated'
      let arrContractTypeIds = MethodService.findListItemDifferent(this.listContractType, 'id')
      let filterBuild = Filter.elementMatch('job_info', [
        Filter.in("contract_type_id", arrContractTypeIds),
        Filter.and(
          Filter.lte('start_date', '$$now'),
          Filter.or(
            Filter.isNull('end_date'),
            Filter.gte('end_date', '$$now')
          )
        )
      ]).build()
      let filter = `status:in:DANG_LAM_VIEC,NGHI_SINH&job_info.contract_type_id:in:${arrContractTypeIds.join(',')}&${filterBuild}`
      this.goToEmployeeFilter(filter)
    },
    goToEmployeeWorkExperience(data) {
      this.seniority = data
      let filterBuild = ''
      let arrValue = data.split('-')
      let key = 'start_work_date'
      if (arrValue[0] == '0') { //0-1 năm kinh nghiệm
        filterBuild = Filter.or(
            Filter.gt(key, '$$now-1years'),
            Filter.gt(key, '$$now'),
            Filter.isNull(key),
          ).build()
      } else if (arrValue[1] == '0') { //7+ năm kinh nghiệm
        filterBuild = Filter.lte(key, '$$now-7years').build()
      } else {
        filterBuild = Filter.and(
          Filter.lte(key, `$$now-${arrValue[0]}years`),
          Filter.gt(key, `$$now-${arrValue[1]}years`),
        ).build()
      }
      let filter = `status:in:DANG_LAM_VIEC,NGHI_SINH&${filterBuild}`
      this.goToEmployeeFilter(filter)
    },
    goToEmployeeGender(type) {
      let filterBuild
      if (type == 'Nam') {
        filterBuild = Filter.eq('administrative_info.gender', 1)
      } else if (type == 'Nữ') {
        filterBuild = Filter.eq('administrative_info.gender', 0)
      } else {
        filterBuild = Filter.eq('administrative_info.gender', 2)
      }
      let filter = `status:in:DANG_LAM_VIEC,NGHI_SINH&${filterBuild}`
      this.goToEmployeeFilter(filter)
    },
    goToEmployeeContractType(id) {
      this.constractValidity = 'validated'
      let filterBuild = Filter.and(
        Filter.in('job_info.contract_type_id', [id]),
        Filter.elementMatch('job_info', [
          Filter.in("contract_type_id", [id]),
          Filter.and(
            Filter.lte('start_date', '$$now'),
            Filter.or(
              Filter.gte('end_date', '$$now'),
              Filter.isNull('end_date'),
            )
          )
        ])
      ).build()
      let filter = `status:in:DANG_LAM_VIEC,NGHI_SINH&${filterBuild}`
      this.goToEmployeeFilter(filter)
    },
    goToEmplopyeeInsurance() {
      let filterBuild = Filter.and(
        Filter.isNull('salary.insurance_salary', false)
      )
      let filter = `status:in:DANG_LAM_VIEC,NGHI_SINH&${filterBuild}`
      this.goToEmployeeFilter(filter)
    },
    goToEmployeeFilter(filter) {
      this.$router.push({
        name: 'Admin-EmployeeManager-list',
        query: {
          filters: filter,
          constractValidity: this.constractValidity,
          seniority: this.seniority,
        }
      }).catch(() => {})
    },
    async getAllEmployee() {
      //Tổng số nhân viên
      let promiseTotalEmployee = this.listEmployee.filter(item => {
        return item.status === 'DANG_LAM_VIEC' || item.status === 'NGHI_SINH'
      })
      //Tổng số nhân viên đang làm việc
      let promiseTotalEmployeeWorking = this.listEmployee.filter(item => {
        return item.status === 'DANG_LAM_VIEC'
      })
      //Tổng số nhân viên đóng bảo hiểm
      let promiseTotalMaternityLeave = this.listEmployee.filter(item => {
        return item.status != 'DA_NGHI' && item.salary && item.salary.insurance_salary != null
      })
      //Tổng số hợp đồng
      let promiseTotalEmployeeContract = this.listEmployee.filter(item => {
        let haveValidJob = MethodService.getValidJobInfo(item.job_info, this.arrContractTypeIds)
        return haveValidJob && haveValidJob.length > 0
      })
      //Tổng số hợp đồng quá hạn
      let promiseExpriedJob = this.listEmployee.filter(item => {
        let haveExpiredJob = MethodService.getExpriedJobInfo(item.job_info, this.arrContractTypeIds)
        // haveExpiredJob = haveExpiredJob.filter(job => {
        //   return this.listContractType.find(contract => {
        //     return contract.id == job.contract_type_id;
        //   })
        // })
        if (haveExpiredJob && haveExpiredJob.length > 0) {
          return item.job_info.length == haveExpiredJob.length;
        }
      })
      //Tổng số hợp đồng sắp hết hạn
      let promiseToBeExpriedJob = this.listEmployee.filter(item => {
        //Danh sách hợp đồng còn hạn
        let haveValidJob = MethodService.getValidJobInfo(item.job_info, this.arrContractTypeIds)
        if (haveValidJob.length > 0) {
          //Danh sách hợp đồng còn hiệu lực dài hạn
          let longTermJobInfo = MethodService.getLongTermJobInfo(haveValidJob, this.arrContractTypeIds)
          return longTermJobInfo.length <= 0
        }
      })
      Promise.all([
        promiseTotalEmployee,
        promiseTotalEmployeeWorking,
        promiseTotalMaternityLeave,
        promiseTotalEmployeeContract,
        promiseExpriedJob,
        promiseToBeExpriedJob
      ])
        .then(values => {
          this.totalEmployee = values[0].length
          this.totalEmployeeWorking = values[1].length
          this.totalMaternityLeave = values[2].length
          this.totalEmployeeContract = values[3].length
          this.totalContractExpired = values[4].length
          this.totalContractToBeExpired = values[5].length
        })
    },
    formartNumber(value) {
      if (value < 10) {
        return "0" + value
      } else if ( value >= 1000) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      } else {
        return value
      }
    },
    getTypeContract() {
      let arrValidJobInfo = []
      this.listEmployee.forEach(item => {
        let validJob = MethodService.getValidJobInfo(item.job_info, this.arrContractTypeIds)
        validJob.forEach((item, index) => {
          arrValidJobInfo.push(item)
        })
      })
      let promisses = this.listContractType.map(item => {
        return {
          value: arrValidJobInfo.filter(item2 => {
            return item2.contract_type_id === item.id
          }).length,
          name: item.name,
          id: item.id
        }
      })
      Promise.all(promisses).then(res => {
        res.forEach(item => {
          if (item.value === 0) {
            item.value = ''
          }
        })
        this.setDataChartTypeContract(res)
      })
    },
    setDataChartTypeContract(data) {
      this.showChartTypeContract = false
      this.optionChartTypeContract = {
        tooltip: {
          trigger: 'item',
          textStyle: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 400,
          }
        },
        series: [
          {
            name: 'Loại hợp đồng',
            type: 'pie',
            radius: '55%',
            color: DataService.listColors,
            label: {
              textStyle: {
                fontSize: 16,
                fontFamily: 'UTM Avo',
                fontWeight: 'bold'
              }
            },
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 5,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      setTimeout(() => {
        this.showChartTypeContract = true
      }, 1500)
    },
    getWorkExperience() {
      let dataMale = [0, 0, 0, 0, 0]
      let dataFemale = [0, 0, 0, 0, 0]
      let dataOther = [0, 0, 0, 0, 0]
      this.listEmployee.forEach(item => {
        let seniority = MethodService.calculatorSeniority(item.start_work_date)
        switch(item.administrative_info.gender) {
          case 0:
            if (seniority < 1) {
              dataFemale[0] += 1
            } else if (seniority >= 1 && seniority < 3) {
              dataFemale[1] += 1
            } else if (seniority >= 3 && seniority < 5) {
              dataFemale[2] += 1
            } else if (seniority >= 5 && seniority < 7) {
              dataFemale[3] += 1
            } else {
              dataFemale[4] += 1
            }
            break
          case 1:
            if (seniority < 1) {
              dataMale[0] += 1
            } else if (seniority >= 1 && seniority < 3) {
              dataMale[1] += 1
            } else if (seniority >= 3 && seniority < 5) {
              dataMale[2] += 1
            } else if (seniority >= 5 && seniority < 7) {
              dataMale[3] += 1
            } else {
              dataMale[4] += 1
            }
            break
          case 2:
            if (seniority < 1) {
              dataOther[0] += 1
            } else if (seniority >= 1 && seniority < 3) {
              dataOther[1] += 1
            } else if (seniority >= 3 && seniority < 5) {
              dataOther[2] += 1
            } else if (seniority >= 5 && seniority < 7) {
              dataOther[3] += 1
            } else {
              dataOther[4] += 1
            }
            break
        }
      })
      this.setDataChartWorkExperience(dataMale, dataFemale, dataOther)
    },
    setDataChartWorkExperience(dataMale, dataFemale, dataOther) {
      this.showChartWorkExperience = false
      this.optionChartWorkExperience = {
        name: 'WorkExperien',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          textStyle: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 400,
          }
        },
        grid: {
          top: '3%',
          left: '3%',
          right: '3%',
          bottom: '2%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['0-1 năm', '1-3 năm', '3-5 năm', '5-7 năm', '7+ năm'],
          axisLabel: {
            fontSize: 15,
            fontFamily: 'UTM Avo',
            fontWeight: 'bold',
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            fontSize: 15,
            fontFamily: 'UTM Avo',
          }
        },
        series: [
          {
            name: 'Nam',
            type: 'bar',
            stack: 'total',
            color: "#1F8FFF",//30F363
            data: dataMale
          },
          {
            name: 'Nữ',
            type: 'bar',
            stack: 'total',
            color: "#30F363", //1F8FFF
            data: dataFemale
          },
          {
            name: 'Khác',
            type: 'bar',
            stack: 'total',
            color: "#B2B2B2",
            data: dataOther
          },
        ]
      }
      setTimeout(() => {
        this.showChartWorkExperience = true
      }, 1500)
    },
    getPersonnelByDepartment() {
      let arrNameDepartment = []
      this.listDepartment.forEach(item => {
        arrNameDepartment.push({
          id: item.id,
          name: item.name,
        })
      })
      let arrValidJobInfo = []
      this.listEmployee.forEach(item => {
        // let validJob = MethodService.getValidJobInfo(item.job_info, this.arrContractTypeIds)
        item.job_info.forEach((item_job) => {
          if (!item_job.department_id) return
          item_job.employee_no = item.employee_no
          let checkExist = arrValidJobInfo.find(validJob => {
            return validJob.department_id == item_job.department_id  && validJob.employee_no == item.employee_no
          })
          if (!checkExist) arrValidJobInfo.push(item_job)
        })
      })
      let promisses = arrNameDepartment.map(item => {
        return {
          id: item.id,
          name: item.name,
          total: arrValidJobInfo.filter(item2 => {
            return item2.department_id === item.id
          }).length
        }
      })
      Promise.all(promisses).then(res => {
        let dataLabel = res.map(item => item.name)
        let dataValue = res.map((item,index) => {
          return {
            value: item.total,
            itemStyle: {
              color: DataService.listColors[index]
            },
            department_id: item.id
          }
        })
        this.setDataChartPersonnelByDepartment(dataLabel, dataValue)
      })
    },
    setDataChartPersonnelByDepartment(dataLabel, dataValue) {
      this.showChartPersonnelByDepartment = false
      this.optionChartPersonnelByDepartment = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          textStyle: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 400,
          }
        },
        grid: {
          top: '3%',
          left: '2%',
          right: '2%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: dataLabel,
            axisLabel: {
              fontSize: 15,
              fontFamily: 'UTM Avo',
              fontWeight: 'bold',
              rotate: 70,
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              fontSize: 15,
              fontFamily: 'UTM Avo',
            }
          }
        ],
        series: [
          {
            name: 'Nhân sự',
            type: 'bar',
            barWidth: '60%',
            data: dataValue,
          }
        ]
      }
      setTimeout(() => {
        this.showChartPersonnelByDepartment = true
      }, 1500);
    },
    getGender() {
      let promisesFemale = this.listEmployee.filter(item => {
        return item.administrative_info.gender === 0
      })
      let promisesMale = this.listEmployee.filter(item => {
        return item.administrative_info.gender === 1
      })
      let promisesOther = this.listEmployee.filter(item => {
        return item.administrative_info.gender === 2
      })
      Promise.all([promisesFemale, promisesMale, promisesOther]).then(res => {
        let data = [
          {
            name: 'Nữ',
            value: res[0].length == 0 ? '' : res[0].length,
          },
          {
            name: 'Nam',
            value: res[1].length == 0 ? '' : res[1].length,
          },
          {
            name: 'Khác',
            value: res[2].length == 0 ? '' : res[2].length,
          },
        ]
        this.setDataChartGender(data)
      })
    },
    setDataChartGender(data) {
      this.showChartGender = false
      this.optionChartGender = {
        tooltip: {
          trigger: 'item',
          textStyle: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 400,
          }
        },
        series: [
          {
            name: 'Giới tính',
            type: 'pie',
            color: ['#30F363', '#1F8FFF', '#B2B2B2'],
            label: {
              textStyle: {
                fontSize: 16,
                fontFamily: 'UTM Avo',
                fontWeight: 'bold',
              }
            },
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 5,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      setTimeout(() => {
        this.showChartGender = true
      }, 1500);
    },
  },
  async created() {
    // blockUi()
    // setTimeout(async () => {
    //   await this.getAllEmployee()
    //   await this.getPersonnelByDepartment()
    //   await this.getGender()
    //   await this.getWorkExperience()
    //   await this.getTypeContract()
    //   setTimeout(() => {
    //     unblockUi()
    //   }, 1800);
    // }, 1000);
  },
  watch: {
    listContractType() {
      this.arrContractTypeIds = MethodService.findListItemDifferent(this.listContractType, 'id')
    },
    listEmployee() {
      blockUi()
      this.getAllEmployee()
      this.getPersonnelByDepartment()
      this.getGender()
      this.getWorkExperience()
      this.getTypeContract()
      setTimeout(() => {
        unblockUi()
      }, 1800);
    },
  }
}
</script>

<style lang="scss" scoped>
a:hover {
  text-decoration: none;
}
.main-body__css{
  .card-md-12 {
    margin-bottom: 14px;
  }
}
::v-deep .el-card {
  .el-card__header{
    padding: 15px 15px 10px 15px;
    .card-header__css {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-select  {
        max-width: 150px;
        .el-input__inner {
          height: 33px !important;
        }
      }
    }
    .card-header__title{
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 700;
      font-size: 15px;
      line-height: 18px;
      color: #000000;
      margin-bottom: 6px;
    }
    .card-header__sub {
      color: #ABABAB;
      font-style: italic;
      font-weight: 300;
      font-size: 14px;
      line-height: 16px;
    }
  }
  .el-card__body{
    padding: 0 10px 15px 10px;
    .card-body__chart {
      min-height: 415px;
    }
    .card-body-md-12 {
      &.card-body--flex {
        display: flex;
        justify-content: space-around;
        padding-top: 15px;
      }

      .title--text {
        font-family: 'Roboto';
        text-transform: uppercase;
        font-weight: 600;
        font-size: 15px;
        line-height: 18px;
        color: #ABABAB;
        margin-bottom: 10px;
      }
      .value {
        font-family: 'Roboto';
        font-weight: bolder;
        font-size: 30.8571px;
        line-height: 36px;
      }
      .unit {
        font-family: 'Roboto';
        font-weight: 500;
        font-size: 15px;
        line-height: 18px;
        color: #ABABAB;
      }
      .total-employee__value {
        color: #FF7E07;
      }
      .working__value {
        color: #017EFA;
      }
      .maternity-leave__value {
        color: #FD1F9B;
      }

      [class^="col-"], [class*=" col-"] {
        padding-right: 5px;
        padding-left: 5px;
      }
      .card-body__block{
        position: relative;
        height: 120px;
        border-radius: 10px;
        color: #FFFFFF;
        padding: 17px 23px;
        &:hover {
          cursor: pointer;
        }
        .count {
          font-family: 'Roboto';
          font-weight: 700;
          font-size: 26px;
          line-height: 28px;
          color: #FFFFFF;
        }
        .title {
          font-family: 'Roboto';
          font-weight: 500;
          font-size: 16px;
          line-height: 19px;
          color: #FFFFFF;
          width: 120px;
        }
        .icon {
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
          right: 25px;
          [class^="isax-bold-"] {
            &::before {
              font-size: 40px;
              line-height: 40px;
            }
          }
        }
        &.total-contract__block{
          background: #0AB8B6;
        }
        &.contract-expire__block{
          background: #4690CD;
        }
        &.contract-extended__block{
          background: #3753A6;
        }
        &.overdue-contract__block{
          background: #5A51A2;
        }
      }
    }
  }
}
</style>
